import { IHttpService } from "../../core/service/HttpService";
import Constants from "../common/Constants";

export interface IIndexTypeGroupService {
  addItemsToIndexTypeGroup(groupId: number, itemIds: number[]): void;
  addChildGroupsToIndexTypeGroup(groupId: number, groupIds: number[]): void;
}

const IndexTypeGroupService = ({ httpService }): IIndexTypeGroupService => {
  const _http: IHttpService = httpService;
  const _baseUrl: string = "/api";

  return {
    async addItemsToIndexTypeGroup(groupId: number, typeIds: number[]) {
      const path = _http.buildPath(
        _baseUrl,
        Constants.indexGroupBasePath,
        groupId.toString(),
        Constants.itemsPath
      );
      const response = await _http.put(path, {
        form: false,
        params: typeIds
      });
      return _http.toText(response);
    },
    async addChildGroupsToIndexTypeGroup(groupId: number, groupIds: number[]) {
      const path = _http.buildPath(
        _baseUrl,
        Constants.indexGroupBasePath,
        groupId.toString(),
        Constants.childGroupsPath
      );
      const response = await _http.post(path, {
        form: false,
        params: groupIds
      });
      return _http.toText(response);
    }
  };
};
export default IndexTypeGroupService;
